import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();

const appInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory }
    },
    enableAutoRouteTracking: true,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    disableFetchTracking: false,
    disableAjaxTracking: false
  }
});

// Only initialize if connection string is present
if (process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING) {
  appInsights.loadAppInsights();

  // Global error handler - catches uncaught errors in event handlers, etc.
  window.onerror = (message, source, lineno, colno, error) => {
    appInsights.trackException({
      exception: error || new Error(String(message)),
      properties: { source, lineno, colno, type: 'window.onerror' }
    });
    return false; // Let error propagate to console
  };

  // Unhandled promise rejection handler
  window.onunhandledrejection = (event: PromiseRejectionEvent) => {
    appInsights.trackException({
      exception: event.reason instanceof Error
        ? event.reason
        : new Error(String(event.reason)),
      properties: { type: 'unhandledrejection' }
    });
  };
}

export { appInsights, reactPlugin };
